import { TableRowDisplayEvent } from "@mcleod/components";
import { AutogenLayoutTariffRegionLookup } from "./autogen/AutogenLayoutTariffRegionLookup";

export class TariffRegionLookup extends AutogenLayoutTariffRegionLookup {

    /** This is an event handler for the onRowDisplay event of tableTariffRegionLookup.  */
    tableTariffRegionLookupOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        if (tableRow.index > 0) {
            tableRow.table.rows[tableRow.index - 1].borderBottomWidth = 1;
        }
    }
}
